import RecipePills from "./RecipePills";

export default RecipePills;
